<template>
  <div class="index" v-cloak>
    <!-- 头部 -->
    <HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
    <HeaderView @showLoginPop="showLoginPopFn"></HeaderView>
    <NavView></NavView>
    <!-- 内容 -->
    <div class="content">
      <!-- banner区域 -->
      <section class="banner_div word flex_between">
        <article class="banner_left">
          <div class="banner_left_title flex_center">
            {{ $t("homePage.product") }}
          </div>
          <div class="banner_left_ul">
            <div
              class="banner_left_li flex_between"
              v-for="(item, index) in product"
              :key="index"
              @click="products(item.catalogId)"
            >
              <i>
                <img src="@/assets/images/banner_left1.png" alt />
              </i>
              <div class="banner_left_li_text">
                <div class="left_li_text_top flex_between">
                  <span>{{ item.catalogName }}</span>
                  <img src="@/assets/images/right_jiantou.png" alt />
                </div>
                <div class="left_li_text_bottom">
                  <span v-for="(items, indexs) in item.children" :key="indexs">
                    <div class="clamp1">{{ items.catalogName }}</div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </article>

        <div class="banner_swiper flex_between">
          <div class="swiper-container gallery_top">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                @click="detail(liem.linkUrl)"
                v-for="(liem, index) in img1.bigBanner"
                :key="index"
                :style="{
                  backgroundImage:
                    'url(' +
                    (liem.imgUrl
                      ? liem.imgUrl
                      : '@/assets/images/home_banner1.jpg') +
                    ')',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }"
              ></div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next swiper-button-white"></div>
            <div class="swiper-button-prev swiper-button-white"></div>
          </div>
          <div class="swiper-container gallery_thumbs">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                @click="detail(liem.linkUrl)"
                v-for="(liem, index) in img1.smallBanner"
                :style="{
                  backgroundImage:
                    'url(' +
                    (liem.imgUrl
                      ? liem.imgUrl
                      : '@/assets/images/home_banner1.jpg') +
                    ')',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }"
              ></div>
            </div>
          </div>
        </div>

        <article class="banner_right">
          <div class="banner_right_user flex_between">
            <i>
              <img src="@/assets/images/logo.png" alt class="w100" />
            </i>
            <div class="banner_right_user_text flex_between">
              <span>Hi~{{ $t("homePage.hi") }}</span>
              <div class="login flex_start" v-if="!isUser">
                <a href="javaScript:void(0)" @click="login">{{
                  $t("homePage.sign")
                }}</a>
                <a href="javaScript:void(0)" @click="register">{{
                  $t("homePage.register")
                }}</a>
              </div>
              <div v-else>
                <div v-if="user.country == '中国'">
                  <span>{{ user.surname }}</span>
                  <span>{{ user.name }}</span>
                </div>
                <div v-else>
                  <span>{{ user.name }}</span>
                  <span>{{ user.surname }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="banner_right_information">
            <div class="information_top flex_between" @click="informations">
              <div class="information_title">
                {{ $t("homePage.newsflash") }}
              </div>
              <span class="flex_center">
                {{ $t("homePage.more") }}
                <img src="@/assets/images/right_jiantou.png" alt />
              </span>
            </div>
            <div class="information_ul">
              <div
                class="information_li flex_between"
                v-for="(liem, index) in information"
                :key="index"
              >
                <span class="information_li_tips flex_center">{{
                  $t("homePage.recommend")
                }}</span>
                <div class="information_li_text">{{ liem.title }}</div>
              </div>
            </div>
          </div>
          <div class="class_ul">
            <div class="class_bt flex_between">
              <router-link to="/footPrint/all">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/class_img.png" alt />
                  </i>
                  <span>{{ $t("homePage.footprint") }}</span>
                </div>
              </router-link>
              <router-link to="/membercenter">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/huiyuan.png" alt />
                  </i>
                  <span>{{ $t("homePage.member") }}</span>
                </div>
              </router-link>
              <router-link to="/membercenter">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/zhanghu.png" alt />
                  </i>
                  <span>{{ $t("homePage.account") }}</span>
                </div>
              </router-link>
            </div>
            <div class="class_bt flex_between">
              <router-link to="/mine/message">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/xiaoxi.png" alt />
                  </i>
                  <span>{{ $t("homePage.news") }}</span>
                </div>
              </router-link>
              <router-link to="/all/order">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/dingdan.png" alt />
                  </i>
                  <span>{{ $t("homePage.order") }}</span>
                </div>
              </router-link>
              <router-link to="/remote/technology">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/yuancheng.png" alt />
                  </i>
                  <span>{{ $t("homePage.long_range") }}</span>
                </div>
              </router-link>
            </div>
            <div class="class_bt flex_between">
              <router-link to="/balance/MyBalance">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/qianbao.png" alt />
                  </i>
                  <span>{{ $t("homePage.wallet") }}</span>
                </div>
              </router-link>
              <router-link to="/myProject/MyProject">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/xiangmu.png" alt />
                  </i>
                  <span>{{ $t("homePage.project") }}</span>
                </div>
              </router-link>
              <router-link to="/collection/all">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/shoucang.png" alt />
                  </i>
                  <span>{{ $t("homePage.Collection") }}</span>
                </div>
              </router-link>
            </div>
            <div class="class_bt flex_between">
              <router-link to="/memberCenterDetail?i=0">
                <div class="class_li">
                  <i>
                    <img src="@/assets/images/ziliao.png" alt />
                  </i>
                  <span>{{ $t("homePage.data") }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </article>
      </section>
      <!-- 热门推荐 -->
      <section class="recommend word section_div">
        <div class="recommend_top">
          <div class="recommend_title">
            <div class="recommend_title_left flex_start">
              <h4>{{ $t("homePage.hot") }}</h4>
            </div>
            <div class="recommend_nav_wrapper">
              <div class="nav_arrow left_arrow" @click="scrollNav('left')" v-show="showArrows">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="recommend_nav_container" :class="{'has-arrows': showArrows}">
                <div class="recommend_nav_ul">
                  <span
                    class="flex_center"
                    v-for="(item, index) in homeTab"
                    @click="changeProMsg(index)"
                    :class="{ selection: catalogId == item.catalogId }"
                    >{{ item.catalogName }}</span
                  >
                </div>
              </div>
              <div class="nav_arrow right_arrow" @click="scrollNav('right')" v-show="showArrows">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="flex_between recommend_ul">
            <div
              class="recommend_ul_l"
              v-if="leftPro.productName"
              @click="det(leftPro.productId)"
            >
              <div class="recommend_li_img mt30">
                <img :src="$img + leftPro.productImg.split(',')[0]" alt />
              </div>
              <div class="recommend_li_text">
                <div class="recommend_li_text_title mt20 mb10">
                  {{ leftPro.productName }}
                </div>
                <div class="recommend_li_text_span mb10">
                  {{ leftPro.productDescribe }}
                </div>
                <div class="recommend_li_text_money mb10">
                  {{ $type == 1 ? "￥" : "$" }} {{ leftPro.unitPrice / 100 }}
                </div>
                <div class="recommend_li_text_tag mb10">
                  {{ $t("homePage.Hots") }}
                </div>
                <div @click="(e) => (e.cancelBubble = true)" class="more-btn">
                  {{ $t("homePage.more") }}
                </div>
                <div
                  @click="(e) => (e.cancelBubble = true)"
                  class="price-index"
                >
                  <p v-for="item in leftPro.$priceIndex">
                    {{
                      $t("product.buy") +
                      " " +
                      item.num +
                      "," +
                      $t("product.unitPrice") +
                      `${$type == 1 ? "￥" : "$"}` +
                      item.price / 100
                    }}；
                  </p>
                </div>
              </div>
            </div>

            <div
              class="recommend_ul_r flex_start flex_wrap"
              v-if="data.length != 0"
            >
              <div
                class="recommend_ul_li flex_center"
                v-for="(item, index) in data"
                :key="index"
                @click="det(item.productId)"
              >
                <!-- <span class="recommend_li_tag recommend_li flex_center">满200减200元</span> -->
                <div class="recommend_li_img flex_center">
                  <img :src="$img + item.productImg.split(',')[0]" alt />
                </div>
                <div class="recommend_li_text">
                  <!-- <div :style="'background:' + ((index % 2 === 1) ? '#0c9ae2;' : '#efc48d;')" class="recommend_li_text_title product_name">{{item.productName}}</div> -->
                  <div class="recommend_li_text_span product_num">
                    {{ item.productNum }}
                  </div>
                  <div class="recommend_li_text_span">
                    类别：{{ item.productName }}
                  </div>
                  <div class="recommend_li_text_tag">
                    {{
                      $t("product.goodsLoop") + "：" + (item.goodsLoop || "")
                    }}
                  </div>
                  <div class="recommend_li_text_money" style="font-size: 12px">
                    {{
                      $t("product.price") +
                      `：${$type == 1 ? "￥" : "$"}` +
                      (item.unitPrice / 100).toFixed(2)
                    }}
                  </div>

                  <div class="more_dv">
                    <div
                      style="float: right"
                      class="more-btn"
                      @click="(e) => (e.cancelBubble = true)"
                    >
                      {{ $t("homePage.more") }}
                    </div>
                    <div
                      @click="(e) => (e.cancelBubble = true)"
                      class="price-index price-item-position"
                    >
                      <p
                        class="price-index-label"
                        v-for="item1 in item.$priceIndex"
                      >
                        <span
                          >{{ $t("product.buy") + " "
                          }}<span style="color: #000">{{
                            item1.num
                          }}</span></span
                        >
                        <span
                          >{{ $t("product.unitPrice")
                          }}<span style="color: 000">{{
                            `${$type == 1 ? "￥" : "$"}` +
                            (item1.price / 100).toFixed(2)
                          }}</span></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!leftPro.productName" class="no-msg">
              {{ $t("placeorder.Nodata") }}
            </div>
          </div>
        </div>
        <div class="recommend_bottom flex_between">
          <div class="recommend_bottom_l">
            <div class="recommend_bottom_l_img">
              <img v-if="$type===1" src="@/assets/images/new_bg.png" alt class="home_img" />
              <img v-else src="@/assets/images/new_bg_en.png" alt class="home_img" />
            </div>
          </div>
          <div class="recommend_bottom_r">
            <div class="recommend_bottom_r_ul">
              <div
                class="recommend_bottom_r_li"
                v-for="(item, index) in newArr"
                :key="index"
                @click="det(item.productId)"
              >
                <div class="recommend_bottom_r_li_top flex_center">
                  {{ item.productName }}
                </div>
                <div class="recommend_bottom_r_li_img flex_between">
                  <i>
                    <img
                      :src="
                        item.productImg
                          ? $img + item.productImg.split(',')[0]
                          : ''
                      "
                      alt
                    />
                  </i>
                  <div class="recommend_bottom_r_li_img_name">
                    {{ item.productNum }}
                  </div>
                </div>
                <div class="recommend_bottom_r_li_bottom">
                  <ul class="recommend_bottom_r_li_text flex_start">
                    <li>
                      {{ item.productDescribe }}
                    </li>
                  </ul>
                  <div class="recommend_bottom_r_li_money flex_center">
                    <div class="money_num flex_center">
                      {{ `${$type == 1 ? "￥" : "$"}` + item.unitPrice / 100 }}
                    </div>
                    <div class="money_tag flex_center">
                      {{ $t("homePage.Newproducts") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="recommend word section_div">
        <div class="recommend_top">
          <div class="flex_between recommend_title">
            <div class="recommend_title_left flex_start">
              <h4>{{ $t('homePage.solution') }}</h4>
            </div>
            <router-link to="/solution">
              <div class="flex_start flex_items">
                <div>{{ $t('homePage.more') }}</div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </router-link>
          </div>
          <div class="flex_start">
            <div
              v-for="(item, index) in solutionArr"
              :key="index"
              class="solution_list"
              @click="solutionDetails(index)"
            >
              <img :src="$img + item.url" alt />
              <div class="text-left">{{ item.schemeName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="recommend gy_dv">
        <div class="recommend_top word">
          <div class="flex_between recommend_title">
            <div class="recommend_title_left flex_start">
              <h4>{{ $t('homePage.aboutUS') }}</h4>
              <!-- <span>/ ABOUT US</span> -->
            </div>
          </div>
          <div class="flex_start">
            <div class="company">
              <div>{{ $t('aboutUS.cp') }}</div>
              <!-- <div>公司简介 / Company profile</div> -->
              <img :src="$img + msg.frontCover" alt class="" />
              <div class="kf_txt">
                {{ msg.synopsis }}
              </div>
              <router-link to="/aboutUs">
                <div class="flex_start">
                  <div class="btn">{{ $t("aboutUS.idea") }}</div>
                  <div class="btn">{{ $t("aboutUS.Mainbusiness") }}</div>
                  <div class="btn">{{ $t("aboutUS.purpose") }}</div>
                </div>
              </router-link>
            </div>
            <div class="Journalism">
              <div class="flex_between">
                <!-- <div>新闻资讯 / news information</div> -->
                <div>{{ $t('aboutUS.newForm') }}</div>

                <div @click="informations">{{ $t("homePage.more") }} ›</div>
              </div>
              <div
                class="flex_start dv"
                :class="{ bor: index == 0 || index == 1 }"
                v-for="(liem, index) in information"
                :key="index"
                v-if="index < 3"
                @click="detnew(liem.nid)"
              >
                <img :src="liem.imageUrl" alt class="" />
                <div>
                  <div class="title">{{ liem.title }}</div>
                  <div class="txt">
                    {{ liem.viceTitle }}
                  </div>
                </div>
              </div>
            </div>
            <div class="kf">
              <!-- <div>客服中心 / Customer service center</div> -->
              <div>{{ $t('aboutUS.customer') }}</div>

              <div class="dv">
                <div class="kf_txt mb10">
                  {{ $t("homePage.kfTime") }}：9:00—18.00
                </div>
                <div class="kf_txt mb10">
                  {{ $t("homePage.Telephone") }}：（0086+）028-83352679-8027
                </div>
                <div class="kf_txt mb10">
                  {{ $t("homePage.PreSsale") }}：hxsq@hanxinchip.cn
                </div>
                <div class="kf_txt mb10">
                  {{ $t("homePage.AfterSales") }}：hxsh@hanxinchip.cn
                </div>
                <img src="@/assets/images/qrCode.png" alt class="qrCode" />
              </div>
              <div class="flex_around box">
                <router-link to="/aboutUs">
                  <div class="btn">
                    <img
                      src="../../assets/images/jianjie.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ $t("homePage.briefintroduction") }}</div>
                  </div>
                </router-link>
                <router-link to="/membercenter">
                  <div class="btn">
                    <img
                      src="../../assets/images/vip.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ $t("homePage.MembershipCenter") }}</div>
                  </div>
                </router-link>
                <router-link to="/mine/message">
                  <div class="btn">
                    <img
                      src="../../assets/images/geren.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ $t("homePage.PersonalCenter") }}</div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <LoginPop v-if="popShow" @closePop="closePopFn"></LoginPop>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
import HeaderView from "@/components/assembly/Header.vue"; //头部模块
import NavView from "@/components/assembly/Nav.vue"; //导航模块
import Footer from "@/components/assembly/Footer.vue"; //导航模块
import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";

export default {
  name: "home",
  data() {
    return {
      priceIndexClass: false,
      num: "1",
      img1: {},
      popShow: false,
      data: [],
      recommend: 0, //热门产品组件
      leftPro: {},
      catalogId: "", //产品主键
      isUser: false, //是否登录
      user: "", //用户名
      product: [], // 所有产品
      information: [], // 汉芯快讯
      newArr: [], // 芯片推荐
      link: [],
      msg: {},
      homeTab: [],
      solutionArr: [],
      scrollStep: 150, // 每次滚动的距离
      showArrows: false, // 控制箭头显示
    };
  },
  components: {
    HeaderView,
    NavView,
    HeaderTopView,
    Footer,
    LoginPop,
  },

  mounted() {
    let that = this;
    this.getSwiperImg();
    this.hotMsg();
    this.isLogin();
    this.getProduct();
    this.getInformation();
    this.getNew();
    this.getLink();
    this.getMsg();
    this.hotProduct();
    this.solutionList();
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkScrollable);
  },
  methods: {
    // 解决方案详情
    solutionDetails(index) {
      this.$router.push({
        path: "/solution",
        query: {
          index: index,
        },
      });
    },
    // 解决方案列表
    solutionList() {
      let url = "/open/schemeList";
      let data = {
        pageNum: 1,
        pageSize: 5,
      };
      this.$post(url, data).then((res) => {
        // console.log(res);
        this.solutionArr = res.rows;
      });
    },
    // 获取热门产品tab
    hotProduct() {
      let url = "/open/product/homeList";
      let data = {
        home: 1,
      };
      this.$post(url, data).then((res) => {
        console.log(res);
        res.data.unshift({
          catalogName: this.$t("homePage.all"),
          catalogId: "",
        });
        this.homeTab = res.data;
        // 在数据加载完成后检查是否需要显示箭头
        this.$nextTick(() => {
          this.checkScrollable();
        });
      });
    },
    // 关于我们
    getMsg() {
      let url = "/open/news/information/we/about";
      this.$get(url).then((res) => {
        if (res.code == 0) {
          this.msg = res.data;
        }
      });
    },
    // 获取友情链接
    getLink() {
      this.$get(`/open/friendLink/getFriendLinkAll`).then((res) => {
        if (res.code == 0) {
          this.link = res.data;
        }
      });
    },
    // 新闻详情
    detnew(nid) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          nid: nid,
        },
      });
    },
    // 轮播图跳转
    detail(nid) {
      let id = nid.split("#");
      if (id[0] == 10011) {
        this.$router.push(`/GoodsDetails?id=${id[1]}`);
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            nid: id[1],
          },
        });
      }
    },
    // 新品推荐
    getNew() {
      let url = "/open/product/productList";
      let data = {
        recommend: 1,
        pageNum: 1,
        pageSize: 4,
        catalogId: this.catalogId,
      };
      this.$post(url, data).then((res) => {
        if (res.code == 0) {
          this.newArr = res.data;
        }
      });
    },
    // 产品详情
    det(id) {
      this.$router.push(`/GoodsDetails?id=${id}`);
    },
    parentFn(payload) {
      console.log("登录" + payload);
    },
    swiperFun() {
      //加载swiper
      var galleryTop = new Swiper(".gallery_top", {
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        spaceBetween: 0,
        paginationClickable: true,
        centeredSlides: true,
        autoplay: 3000,
        circular: true,
        autoplayDisableOnInteraction: false,
        loop: true,
      });
      var galleryThumbs = new Swiper(".gallery_thumbs", {
        circular: true,
        spaceBetween: 10,
        slidesPerView: 3,
        slideToClickedSlide: true,
        direction: "vertical",
        autoplayDisableOnInteraction: false,
        autoplay: 3000,
        loop: true,
      });
    },
    // 跳转到快讯列表
    informations() {
      this.$router.push(`/news`);
    },
    // 汉芯快讯
    getInformation() {
      let that = this;
      let url = `/open/news/information/list?contentType=1&pageNum=1&pageSize=4`;
      this.$get(url).then((res) => {
        if (res.code == 0) {
          that.information = res.data;
        }
      });
    },
    // 跳转到产品中心
    products(e) {
      this.$router.push(`/goodsCenter?id=${e}`);
    },
    // 所有产品分类
    getProduct() {
      let that = this;
      let url = `/open/product/allCatalog`;
      this.$get(url).then((res) => {
        if (res.code == 0) {
          that.product = res.data;
        }
      });
    },
    //轮播图数据
    getSwiperImg() {
      let url = "/open/banner/getBannerAll";
      this.$get(url).then((res) => {
        this.img1 = res.data;
        let that = this;
        this.$nextTick(() => {
          that.swiperFun();
        });
      });
    },
    showLoginPopFn(i) {
      this.popShow = i;
    },
    closePopFn(i) {
      this.popShow = !i;
    },
    //获取热门产品目录
    hotMsg() {
      let url = "/open/product/productList";
      let data = {
        recommend: 3,
        pageNum: 1,
        pageSize: 9,
        catalogId: this.catalogId,
        user: "",
      };
      this.$post(url, data).then((res) => {
        // console.log(res);
        if (res.data.length !== 0) {
          let data = res.data;
          data.forEach((item) => {
            if (item.priceIndex && item.priceIndex !== "null") {
              let temp = JSON.parse(item.priceIndex);
              temp.sort((a, b) => a.num - b.num);
              item.$priceIndex = temp;
            } else {
              item.$priceIndex = [];
            }
          });
          this.leftPro = res.data[0];
          data.splice(0, 1);
          this.data = data;
        } else {
          this.data = [];
          this.leftPro = {};
        }
      });
    },
    //切换热门推荐数据
    changeProMsg(i) {
      this.catalogId = this.homeTab[i].catalogId;
      this.hotMsg();
    },
    login() {
      this.$router.push("/login");
    },
    register() {
      this.$router.push("/register");
    },
    //判断有没有登录
    isLogin() {
      this.isUser = !!sessionStorage.getItem("token");
      let userMsg = JSON.parse(sessionStorage.getItem("user"));
      this.user = userMsg ? userMsg : false;
    },
    // 滚动导航栏
    scrollNav(direction) {
      const container = document.querySelector('.recommend_nav_container');
      const navUl = document.querySelector('.recommend_nav_ul');
      
      if (direction === 'left') {
        container.scrollLeft -= this.scrollStep;
      } else {
        container.scrollLeft += this.scrollStep;
      }
    },
    // 检查是否需要显示箭头
    checkScrollable() {
      const container = document.querySelector('.recommend_nav_container');
      const navUl = document.querySelector('.recommend_nav_ul');
      if (container && navUl) {
        this.showArrows = navUl.scrollWidth > container.clientWidth;
      }
    },
  },
};
</script>

<style scoped>
.text-left {
  text-align: left;
}

.solution_list {
  padding: 10px;
}

.solution_list img {
  height: 300px;
  margin-bottom: 10px;
  width: 210px;
}

.mb10 {
  margin-bottom: 10px;
}

.clamp1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  line-height: 1em;
  font-size: 12px;
}

.qrCode {
  width: 120px;
  height: 120px;
  margin-top: 10px;
}

.mb35 {
  margin-bottom: 35px;
}

.flex_wrap {
  flex-wrap: wrap;
}

.mt20 {
  margin-top: 20px;
}

.mt30 {
  margin-top: 30px;
}

.w100 {
  width: 100%;
}

.link .name {
  margin-right: 10px;
}

.link {
  padding: 60px 0;
  font-size: 12px;
  color: #16325a;
  align-items: center;
}

.kf_txt {
  line-height: 30px;
}

.kf .box {
  text-align: center;
  margin-top: 15px;
}

.kf .icon {
  width: 30px;
  height: 30px;
}

.kf .dv {
  width: 250px;
  background: #f2f9ff;
  padding: 25px 15px;
  font-size: 14px;
  margin-top: 15px;
}

.kf {
  text-align: left;
  width: 280px;
  padding: 25px;
  border: #dde5f1 solid 1px;
}

.gy_dv {
  margin-top: 50px;
  background: white;
}

.company {
  text-align: left;
  width: 350px;
  padding: 25px;
  border: #dde5f1 solid 1px;
}

.company img {
  width: 350px;
  height: 151px;
  padding: 20px 0;
  object-fit: cover;
}

.company .btn {
  width: 100px;
  line-height: 35px;
  background: #f4f4f4;
  text-align: center;
  margin-right: 6px;
  margin-top: 20px;
}

.Journalism {
  width: 425px;
  padding: 25px;
  border: #dde5f1 solid 1px;
  text-align: left;
}

.Journalism img {
  object-fit: cover;
  width: 120px;
  height: 90px;
  margin-right: 10px;
}

.Journalism .dv {
  padding: 20px 0;
  align-items: center;
}

.Journalism .bor {
  border-bottom: rgba(20, 52, 91, 0.2) dashed 1px;
}

.Journalism .title {
  font-size: 15px;
  color: #16325a;
  font-weight: bold;
  margin-bottom: 20px;
}

.Journalism .txt {
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.home_img {
  width: 100%;
  height: 100%;
}

.content {
  background: #f4f4f4;
  padding: 22px 0;
}

/* banner区域 */
/* 左边导航 */
.banner_div {
  align-items: flex-start;
  height: 473px;
}

.banner_div .banner_left {
  width: 20%;
  background: #fff;
  height: 100%;
  margin-right: 10px;
  overflow-y: auto;
}

.banner_div .banner_left::-webkit-scrollbar {
  display: none;
}

.banner_div .banner_swiper {
  width: 60%;
  height: 100%;
}

.banner_div .banner_right {
  width: calc(20% - 30px);
  padding: 15px;
  background: #fff;
  height: calc(100% - 30px);
  margin-left: 10px;
}

.banner_div .banner_left .banner_left_title {
  height: 50px;
  color: #fff;
  background: #0090ff;
  font-size: 15px;
}

.banner_left_ul {
  padding: 8px 17px;
}

.banner_left_li {
  align-items: flex-start;
  padding-top: 10px;
  text-align: left !important;
}

.banner_left_li > i {
  width: 20px;
}

.banner_left_li .banner_left_li_text {
  width: calc(100% - 30px);
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}

.banner_left_li:last-child .banner_left_li_text {
  border: 0;
}

.banner_left_li_text .left_li_text_top span {
  font-size: 15px;
  color: #1a1a1a;
}

.banner_left_li_text .left_li_text_top > img {
  width: 9px;
}

.left_li_text_bottom {
  display: flex;
  flex-wrap: wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.left_li_text_bottom > span {
  margin-top: 7px;
  margin-right: 7px;
  display: inline-block;
  padding-right: 8px;
  line-height: 1.1em;
  border-right: 1px solid #c8c8c8;
  font-size: 10px;
  color: #424355;
}

.left_li_text_bottom > span:last-child {
  margin-right: 0;
  padding-right: 0;
  border-right: 0;
}

/* 中间swiper */
.banner_swiper {
  height: 100%;
}

.banner_swiper .gallery_top {
  width: 100%;
  height: 473px;
}

.banner_swiper .gallery_thumbs {
  width: 190px;
  height: 100%;
}

.gallery_thumbs > .swiper-wrapper > .swiper-slide {
  height: 30%;
  margin-bottom: 10px;
  margin-left: 10px;
}

.gallery_top > .swiper-wrapper > .swiper-slide {
  width: 100% !important;
}

.banner_swiper .swiper-button-white {
  width: 30px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.2);
  background-size: 20px;
}

.banner_swiper .swiper-slide {
  background-size: cover;
}

.banner_swiper .swiper-slide img {
  height: 100%;
}

.banner_swiper .swiper-pagination {
  width: auto;
  left: 37px;
}

.banner_swiper .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  opacity: 0.4;
  border-right: 50%;
  margin-right: 10px;
  margin-left: 0;
}

.banner_swiper
  .swiper-pagination
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 10px;
  height: 10px;
  background: #fff;
  opacity: 1;
  border-right: 50%;
}

/* 右边登录 分类 */
.banner_right .banner_right_user {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 15px;
}

.banner_right_user > i {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.banner_right_user .banner_right_user_text {
  width: calc(100% - 50px);
  align-items: flex-start;
  flex-direction: column;
  height: 40px;
}

.banner_right_user_text > span {
  font-size: 13px;
  color: #676767;
  white-space: nowrap;
}

.banner_right_user_text .login a {
  font-size: 14px;
  color: #000;
  padding: 0 4px;
  border-right: 1px solid #929292;
  line-height: 1em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.banner_right_user_text .login a:last-child {
  border: 0;
}

.banner_right_information {
  border-bottom: 1px solid #e7e7e7;
  height: 108px;
  margin-top: 15px;
  padding-bottom: 15px;
}

.information_top {
  padding-bottom: 10px;
}

.information_top > .information_title {
  font-size: 14px;
  color: #000;
}

.information_top > span {
  font-size: 14px;
  color: #999999;
}

.information_top > span > img {
  width: 10px;
  margin-left: 4px;
}

.information_ul .information_li {
  margin-bottom: 6px;
}

.information_ul .information_li > .information_li_tips {
  /* width: 35px; */
  height: 15px;
  background: #ddeefe;
  color: #5aaff2;
  font-size: 14px;
}

.information_ul .information_li > .information_li_text {
  width: calc(100% - 40px);
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  margin-left: 10px;
}

.class_ul .class_bt {
  padding-top: 14px;
}

.class_ul .class_bt .class_li {
  text-align: center;
  width: 60px;
}

.class_ul .class_bt .class_li > i {
  width: 25px;
  margin: 0 auto;
}

.class_ul .class_bt .class_li > span {
  font-size: 14px;
  margin-top: 8px;
  color: #1a1a1a;
  line-height: 1em;
  display: inline-block;
}

/* 热门推荐 */
.section_div {
  margin-top: 44px;
}

.recommend .recommend_top {
  padding: 26px;
  background: #fff;
}

.recommend .recommend_top .recommend_title {
  padding: 15px 0;
  border-bottom: 1px solid #0e7bd0;
  display: flex;
  align-items: center;
}

.recommend .recommend_top .recommend_title .recommend_title_left {
  align-items: flex-end;
  width: auto;
  flex-shrink: 0;
  margin-right: 20px;
}

.recommend .recommend_top .recommend_title .recommend_title_left > h4 {
  font-size: 24px;
  color: #000;
  margin: 0;
  position: relative;
}

.recommend .recommend_top .recommend_title .recommend_title_left > h4::after {
  content: "";
  position: absolute;
  height: 4px;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #0182de;
  transform: translateY(17px);
}

.recommend .recommend_top .recommend_title .recommend_title_left > span {
  font-size: 13px;
  color: #1a1a1a;
  margin-left: 14px;
}

.recommend .recommend_top .recommend_title .recommend_nav_wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.recommend .recommend_top .recommend_title .recommend_nav_container {
  width: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
  padding: 0;
  display: flex;
}

.recommend .recommend_top .recommend_title .recommend_nav_container.has-arrows {
  width: calc(100% - 60px);
}

.recommend .recommend_top .recommend_title .recommend_nav_ul {
  display: inline-flex;
  white-space: nowrap;
  transition: transform 0.3s ease;
  padding-left: 0;
}

.recommend .recommend_top .recommend_title .recommend_nav_ul > span:first-child {
  margin-left: 0;
}

.nav_arrow {
  flex-shrink: 0;
  margin: 0 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav_arrow:hover {
  background: #0182de;
  color: #fff;
}

.nav_arrow i {
  font-size: 12px;
}

.recommend .recommend_top .recommend_title .recommend_nav_ul > span {
  flex-shrink: 0;
  margin-right: 10px;
  height: 24px;
  padding: 0 15px;
  border-radius: 12px;
  background: #f5f5f5;
  color: #4a4a4a;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.recommend .recommend_top .recommend_title .recommend_nav_ul > span:hover {
  background: #e8f4ff;
  color: #0182de;
}

.recommend .recommend_top .recommend_title .recommend_nav_ul > span.selection {
  background: #0182de;
  color: #fff;
}

.recommend_ul {
  padding: 32px 0;
  height: 320px;
  align-items: flex-start !important;
}

.recommend_ul .recommend_ul_l {
  width: 220px;
  position: relative;
  height: calc(100% - 20px);
  /* background: #F2F9FF; */
  transition: all 0.5s ease;
  border: #c2daec solid 0.5px;
  margin-right: 12px;
}

.recommend_ul .recommend_li_tag {
  position: absolute;
  top: 0;
  left: 0;
  width: 112px;
  height: 20px;
  color: #fff;
  border-radius: 0 0 14px 0;
  background-image: linear-gradient(90deg, #f58555, #fcae6e);
}

.recommend_ul .recommend_li_tag .recommend_li_img {
  height: 156px;
  /*width: 100%;*/
}

.recommend_ul .recommend_li_img > img {
  object-fit: cover;
  margin-right: 5px;
  width: 90px;
  height: 90px;
}

.recommend_ul .recommend_li_text {
  text-align: center;
}

.recommend_ul .recommend_li_text_title {
  /* font-size: 14px; */
  /* color: #0F7BD0; */
  margin-bottom: 5px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.recommend_ul .recommend_li_text_span {
  font-size: 10px;
  /* color: #666666; */
  /* margin-bottom: 10px; */
  /* display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden; */
}

.recommend_ul .recommend_li_text_tag {
  font-size: 10px;
  /* color: #DB7F1C; */
  /* margin-bottom: 10px; */
}

.recommend_ul .recommend_li_text_money {
  font-size: 16px;
  /* color: #cd2232; */
  font-weight: bold;
  /* margin-bottom: 10px; */
}

.recommend_ul .recommend_ul_r {
  width: calc(100% - 220px);
  height: 100%;
}

.recommend_ul_r .recommend_ul_li {
  width: calc(25% - 18px);
  height: 140px;
  display: inline-flex;
  position: relative;
  margin-right: 10px;
  /* padding: 20px 10px 10px 10px; */
  transition: all 0.5s ease;
  border: #c2daec solid 0.5px;
}

.recommend_ul_r .recommend_ul_li .recommend_li_img {
  width: 105px;
  height: 100%;
}

/* 	.recommend_ul_r .recommend_ul_li .recommend_li_img>img {
		height: auto;
	} */

.recommend_ul_r .recommend_ul_li .recommend_li_text {
  width: calc(100% - 125px);
  text-align: left;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.recommend_ul_r .recommend_ul_li:hover {
  background: #f2f9ff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
}

.recommend_ul .recommend_ul_l:hover {
  background: #f2f9ff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
}

.recommend_bottom {
  height: 320px;
  margin-top: 20px;
}

.recommend_bottom_l {
  width: 220px;
  height: 100%;
}

.recommend_bottom_l .recommend_bottom_l_img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-color: #f8f8fa !important;
}

.recommend_bottom_r {
  width: calc(100% - 236px);
  background: #fff;
  height: 100%;
  /* text-align: left; */
}

.recommend_bottom_r_ul {
  padding: 16px 8px;
  height: calc(100% - 32px);
  display: flex;
  align-items: center;
}

.recommend_bottom_r_ul .recommend_bottom_r_li {
  width: 25%;
  margin: 0 8px;
  height: 100%;
  display: inline-block;
  padding-bottom: 5px;
  position: relative;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 8px 0px rgba(134, 134, 134, 0.25);
}

.recommend_bottom_r_li .recommend_bottom_r_li_top {
  height: 44px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  background-image: linear-gradient(180deg, #68a6e4, #199de5);
}

.recommend_bottom_r_li .recommend_bottom_r_li_img {
  height: 132px;
  text-align: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.recommend_bottom_r_li .recommend_bottom_r_li_img > i {
  /* height: 90px; */
  margin-top: 5px;
}

.recommend_bottom_r_li .recommend_bottom_r_li_img > i > img {
  object-fit: cover;
  width: 50%;
}

.recommend_bottom_r_li
  .recommend_bottom_r_li_img
  > .recommend_bottom_r_li_img_name {
  width: 180px;
  margin: 0 auto;
  text-align: center;
  color: #000;
  font-size: 12px;
  padding: 14px 0;
  line-height: 1em;
  white-space: nowrap;
  border-bottom: 1px dashed #e1e1e1;
}

.recommend_bottom_r_li_bottom .recommend_bottom_r_li_text {
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 10px;
  margin-left: -10px;
}

.recommend_bottom_r_li_bottom .recommend_bottom_r_li_text > li {
  font-size: 11px;
  color: #6f6f6f;
  width: 90%;
  text-align: left;
}

.recommend_bottom_r_li_bottom .recommend_bottom_r_li_money {
  height: 26px;
  width: 158px;
  margin: 0 auto;
  border: 1px solid #4a8aa6;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
}

.recommend_bottom_r_li_bottom .recommend_bottom_r_li_money .money_num {
  width: 94px;
  background-image: linear-gradient(180deg, #0487d9, #0c9ae2);
  color: #fff;
  height: 100%;
  font-size: 14px;
}

.recommend_bottom_r_li_bottom .recommend_bottom_r_li_money .money_tag {
  width: 64px;
  font-size: 14px;
  color: #2c78aa;
}

.no-msg {
  width: 100%;
}

.product_name {
  position: absolute;
  top: 0;
  left: 0;
  padding: 3px;
  color: #fff !important;
}

.product_num {
  font-weight: bold;
  /* color: #447dd4 !important; */
  font-size: 14px !important;
  position: absolute;
  left: 14px;
  top: 5px;
  white-space: nowrap;
}

.price-index {
  text-align: left;
  color: #2c78aa;
  background: #fff;
  box-shadow: 1px 1px 15px 1px #ccc;
  padding: 10px;
  border-radius: 5px;
  display: none;
  min-width: 100%;
  z-index: 9999;
}

.more_dv {
  position: absolute;
  right: 10px;
  bottom: 5px;
  width: 100%;
}

.more-btn {
  display: inline-block;
  color: #6367ff;
  cursor: pointer;
}

.more-btn:hover + .price-index {
  display: block !important;
}

.price-index:hover {
  display: block !important;
}

.price-item-position {
  position: absolute;
  cursor: pointer;
}

.price-index-label {
  border-bottom: 1px solid #9cbfff;
  display: flex;
  color: #000 !important;
}

.price-index-label > span {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue